import React, { useState } from "react";
import styles from "./collapsible-group.module.css";
import { ChevronIcon } from "../icons/chevron-icon";
import cn from "classnames";

export interface CollapsibleGroupProps {
  id: string;
  title: React.ReactNode;
  color?: string;
  children: React.ReactNode;
  defaultCollapsed?: boolean;
  onToggle?: (id: string, isCollapsed: boolean) => void;
  showChevron?: boolean;
  emptyStateMessage?: string;
  isEmpty?: boolean;
  className?: string;
  headerClassName?: string;
  contentClassName?: string;
}

export const CollapsibleGroup: React.FC<CollapsibleGroupProps> = ({
  id,
  title,
  color = "#7F869B",
  children,
  defaultCollapsed = false,
  onToggle,
  showChevron = true,
  emptyStateMessage,
  isEmpty = false,
  className,
  headerClassName,
  contentClassName,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(defaultCollapsed);

  const handleToggle = () => {
    const newState = !isCollapsed;
    setIsCollapsed(newState);
    onToggle?.(id, newState);
  };

  return (
    <div className={cn(styles.group, className)}>
      <div
        className={cn(styles.groupHeader, headerClassName)}
        style={{ color }}
        onClick={showChevron ? handleToggle : undefined}
      >
        {showChevron && <ChevronIcon color={color} direction={isCollapsed ? "right" : "down"} />}
        <div className={styles.groupTitle}>
          {typeof title === "string" ? <span className={styles.groupTitleText}>{title}</span> : title}
        </div>
      </div>

      {!isCollapsed && (
        <div className={cn(styles.groupContent, contentClassName)}>
          {isEmpty && emptyStateMessage ? <div className={styles.emptyState}>{emptyStateMessage}</div> : children}
        </div>
      )}
    </div>
  );
};
